import { get, put, post, del, upload } from '@api/request';

export const fetchDocuments = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/documents`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileDocumentStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Document Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDocument = async (
  { litigationService },
  authenticationToken,
  { documentID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDocumentFiles = async (
  { litigationService },
  authenticationToken,
  { documentID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDocumentFile = async (
  { litigationService },
  authenticationToken,
  { documentID, s3ID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}/file/${s3ID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertDocument = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/documents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertDocumentFile = async (
  { litigationService },
  authenticationToken,
  { payload, documentID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updateDocument = async (
  { litigationService },
  authenticationToken,
  { payload, documentID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateDocumentTags = async (
  { litigationService },
  authenticationToken,
  { payload, documentID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteDocument = async (
  { litigationService },
  authenticationToken,
  { documentID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deleteDocumentFile = async (
  { litigationService },
  authenticationToken,
  { payload, documentID, s3ID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadDocumentFile = async (
  { litigationService },
  authenticationToken,
  { documentID, s3ID },
) => {
  const url = `${litigationService}/litigation/document/${documentID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};
